(function () {
  /* ---- Four Cs tab switching ---- */
  const tabs   = document.querySelectorAll('.mt-4c-tab');
  const panels = document.querySelectorAll('.mt-4c-panel');

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach((p) => {
        p.classList.remove('is-active');
        p.hidden = true;
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      panels[i].classList.add('is-active');
      panels[i].hidden = false;
    });
  });

  /* ---- Re-init on theme editor reload ---- */
  document.addEventListener('shopify:section:load', () => {
    if (tabs.length) {
      tabs[0].click();
    }
  });
})();
